import { render, staticRenderFns } from "./AppBurgerHeader.vue?vue&type=template&id=75b4de2b&"
import script from "./AppBurgerHeader.vue?vue&type=script&lang=js&"
export * from "./AppBurgerHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppBurgerHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
